import { FileText, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface UserApplicationsButtonProps {
  applicationCount: number;
  isLoading: boolean;
  onClick: () => void;
}

export const UserApplicationsButton = ({ 
  applicationCount, 
  isLoading, 
  onClick 
}: UserApplicationsButtonProps) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={isLoading}
      className="w-full justify-start text-sm"
    >
      {isLoading ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <FileText className="mr-2 h-4 w-4" />
      )}
      Applications ({isLoading ? '...' : applicationCount})
    </Button>
  );
};